import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { useLastReviewerConfirmStore } from '@/stores/lastReviewerConfirm.store';

/**
 * Global host for the "No reviewer left" confirmation. Mounted once in App;
 * driven by the 409 `release.last_reviewer` handler in services/api.ts.
 */
export const LastReviewerConfirmHost = () => {
  const { t } = useTranslation('common');
  const pending = useLastReviewerConfirmStore((s) => s.pending);
  const settle = useLastReviewerConfirmStore((s) => s.settle);

  const brands = pending?.brands ?? [];
  const description = brands
    .map((b) =>
      t('release_last_reviewer_brand_line', {
        defaultValue: '{{brand}} would have no reviewer.',
        brand: b.name,
      })
    )
    .join(' ');
  const consequence = t('release_last_reviewer_consequence', {
    defaultValue:
      'The release workflow stays on, so nobody can release or schedule new content there, and posts sent for review just wait without anyone being notified. Add a reviewer, or have an agency admin switch on Carte Blanche, to get things moving again.',
  });

  return (
    <ConfirmDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) settle(false);
      }}
      title={t('release_last_reviewer_title', { defaultValue: 'No reviewer left' })}
      description={`${description} ${consequence}`}
      confirmText={t('release_last_reviewer_confirm', { defaultValue: 'Remove anyway' })}
      cancelText={t('release_last_reviewer_cancel', { defaultValue: 'Cancel' })}
      variant="warning"
      onConfirm={() => settle(true)}
      closeOnConfirm={false}
    />
  );
};

export default LastReviewerConfirmHost;
